/**
 * Play-layer preferences — shared and vertical-agnostic.
 *
 * Sound is OFF by default and stays off until the customer turns it on, with a
 * visible toggle. Motion always yields to the operating system's
 * "reduce motion" setting; nothing here ever blocks a tap.
 */
const SOUND_KEY = 'yulontap_play_sound';

export const soundOn = () => {
    try { return localStorage.getItem(SOUND_KEY) === 'on'; } catch (_e) { return false; }
};

export const setSoundOn = (on) => {
    try { localStorage.setItem(SOUND_KEY, on ? 'on' : 'off'); } catch (_e) { /* private mode */ }
};

export const reducedMotion = () => {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_e) { return false; }
};

/** A short, soft pop — synthesised, so no audio file is ever downloaded. */
export const playPop = () => {
    if (!soundOn()) return;
    try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return;
        const ctx = new Ctx();
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(680, ctx.currentTime);
        osc.frequency.exponentialRampToValueAtTime(1180, ctx.currentTime + 0.09);
        gain.gain.setValueAtTime(0.0001, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.16, ctx.currentTime + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.16);
        osc.connect(gain).connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + 0.18);
        setTimeout(() => ctx.close().catch(() => { }), 400);
    } catch (_e) { /* audio unavailable — the tick still works */ }
};

/** A single light tap on phones that support it. Never a long buzz. */
export const lightHaptic = () => {
    try { if (navigator.vibrate) navigator.vibrate(12); } catch (_e) { /* unsupported */ }
};

/** Everything a check-off should feel like, in one call. */
export const tickFeedback = () => { playPop(); lightHaptic(); };
